import { render } from "./loadingTicket.vue?vue&type=template&id=1727e4d2"
import script from "./loadingTicket.vue?vue&type=script&lang=js"
export * from "./loadingTicket.vue?vue&type=script&lang=js"

import "./loadingTicket.vue?vue&type=style&index=0&id=1727e4d2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__